import localStorageWrapper from '../../lib/clients/local-storage-wrapper';
import { type Config } from 'mixpanel-browser';

// Lazy-load mixpanel only if localStorage is supported. importing mixpanel-browser is not supported in sandboxed iframes, and will throw an error.
export async function loadMixpanel(): Promise<MixpanelClient> {
  if (!localStorageWrapper.isSupported()) {
    return emptyMixpanelClient;
  }

  try {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const module = require('mixpanel-browser');
    return module.default as unknown as MixpanelClient;
  } catch {
    return emptyMixpanelClient;
  }
}

export interface MixpanelClient {
  init?: (token: string, config: Partial<Config>) => void;
  track: (
    event: string,
    properties?: Record<string, unknown>,
    options?: { transport?: 'xhr' | 'sendBeacon' }
  ) => void;
  register: (props: Record<string, unknown>) => void;
}
export const emptyMixpanelClient: MixpanelClient = {
  track: () => {},

  register: () => {},
};
